import React, {PropsWithChildren} from 'react';
import {connect} from 'react-redux';
import {Navigate} from "react-router-dom";

import {selectUserRoles} from '../../store/user/selectors';
import APP_URLs from '../../consts/url';
import {USER_ROLES} from '../../consts/user';

export type Props = {
    redirectTo?: APP_URLs,
    roles?: USER_ROLES[],
    checkAccess: Function,
};

export type OwnProps = {
    redirectTo?: APP_URLs,
    checkAccess: Function,
}
const View = ({children, redirectTo, roles, checkAccess}: PropsWithChildren<Props>) => {
    const hasAccess = checkAccess(roles);
    if (!hasAccess) {
            //@TODO: decide how to resolve the pathß to redirect user
        return <Navigate to={redirectTo || APP_URLs.SIGN_IN_ALEXANDR_EREVAN || APP_URLs.SIGN_IN}/>;
    }

    //@TODO: checkPermissions
    return (
        <>
            {children}
        </>
    );

}

//@ts-ignore
const mapStateToProps = (state) => { 
    return {
        roles: selectUserRoles(state),
    }
}

export default connect(mapStateToProps, null)(View);